
import { 
  Item,
} from "@dndModels/item";

export class Container extends Item {
  max_weight: number; // in lbs
  ignore_weight: boolean; // makes it ignore the weight of what's inside when calculating the weight of what is being carried.
  item_types: string[];
  base_item_ids: string[];
  
  constructor(obj?: any) {
    super(obj);
    this.item_type = "Container";
    
    this.max_weight = obj && obj.max_weight ? obj.max_weight : -1;
    this.ignore_weight = obj && obj.ignore_weight ? obj.ignore_weight : false;
    this.item_types = obj && obj.item_types ? obj.item_types : ["ALL"];
    this.base_item_ids = obj && obj.base_item_ids ? obj.base_item_ids : [];
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     this.max_weight = obj.max_weight ? obj.max_weight : -1;
  //     this.ignore_weight = obj.ignore_weight ? obj.ignore_weight : false;
  //     this.item_types = obj.item_types ? obj.item_types : ["ALL"];
  //     this.base_item_ids = obj.base_item_ids ? obj.base_item_ids : [];
  //   }
  // }

  toDBObj(): any {
    const base_db_obj = super.toDBObj();
    return {
      ...base_db_obj,
      max_weight: this.max_weight,
      ignore_weight: this.ignore_weight,
      item_types: this.item_types,
      base_item_ids: this.base_item_ids
    };
  }

  toLight(): any {
    const base_db_obj = super.toLight();
    return {
      ...base_db_obj,
      max_weight: this.max_weight,
      ignore_weight: this.ignore_weight,
      item_types: this.item_types,
      base_item_ids: this.base_item_ids
    };
  }

  copy(copyMe: Container, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.item_type = copyMe.item_type;
    this.b_weight = copyMe.b_weight;
    this.cost = copyMe.cost;
    // this.magical = copyMe.magical;
    this.max_weight = copyMe.max_weight;
    this.ignore_weight = copyMe.ignore_weight;
    this.item_types = copyMe.item_types;
    this.base_item_ids = copyMe.base_item_ids;
  }

  clone(drop_ids = false): Container {
    const new_obj = new Container();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}